import React from 'react';
import './AdditionalBenefits.css';

const AdditionalBenefits = () => {
  return (
    <section
      className="additional-benefits"
      id="benefits"
      style={{
        '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')`
      }}
    >
      <div className="additional-benefits__container">
        <div className="additional-benefits__grid">
          {/* Row 1, Col 1: Header / Title */}
          <div className="additional-benefits__header">
            <h2 className="additional-benefits__title">
              Advantages of Learning Quran Online for Kids & Adults
            </h2>
          </div>

          {/* Row 1, Col 2: Card 2 (24/7 Support) */}
          <div className="additional-benefits__card">
            <div className="additional-benefits__icon-wrapper">
              <svg className="additional-benefits__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </div>
            <h3 className="additional-benefits__card-title">24/7 Support</h3>
            <p className="additional-benefits__card-desc">
              We are available round the clock to make sure you don’t miss your class.
            </p>
          </div>

          {/* Row 1, Col 3: Card 4 (Personalized Tutor) */}
          <div className="additional-benefits__card">
            <div className="additional-benefits__icon-wrapper">
              <svg className="additional-benefits__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
            <h3 className="additional-benefits__card-title">Personalized Tutor</h3>
            <p className="additional-benefits__card-desc">
              Choose from male or female tutors, based on what you are comfortable with.
            </p>
          </div>

          {/* Row 2, Col 1: Card 1 (Live Classes) */}
          <div className="additional-benefits__card">
            <div className="additional-benefits__icon-wrapper">
              <svg className="additional-benefits__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <line x1="9" y1="9" x2="9" y2="15" />
                <line x1="12" y1="12" x2="12" y2="12" />
                <line x1="15" y1="9" x2="15" y2="15" />
              </svg>
            </div>
            <h3 className="additional-benefits__card-title">Live Classes</h3>
            <p className="additional-benefits__card-desc">
              1-on-1 live classes with full attention, every session, no exceptions.
            </p>
          </div>

          {/* Row 2, Col 2: Card 3 (Certificates) */}
          <div className="additional-benefits__card">
            <div className="additional-benefits__icon-wrapper">
              <svg className="additional-benefits__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
              </svg>
            </div>
            <h3 className="additional-benefits__card-title">Certificates</h3>
            <p className="additional-benefits__card-desc">
              We award a completion certificate after the successful evaluation of the completed course.
            </p>
          </div>

          {/* Row 2, Col 3: Card 5 (Real Flexibility) */}
          <div className="additional-benefits__card">
            <div className="additional-benefits__icon-wrapper">
              <svg className="additional-benefits__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="12" y1="19" x2="16" y2="15" />
                <line x1="12" y1="19" x2="8" y2="15" />
              </svg>
            </div>
            <h3 className="additional-benefits__card-title">Real Flexibility</h3>
            <p className="additional-benefits__card-desc">
              Scheduling built around your routine.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalBenefits;


